import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
    selector: 'app-character-count',
    templateUrl: './character-count.component.html',
    styleUrls: ['./character-count.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CharacterCountComponent implements OnInit {
  @Input() control: UntypedFormControl;
  @Input() maxlength: number;

  constructor() {}

  ngOnInit(): void {}
}
